import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        occurrence: '=',
        file: '='
    },
    template: `
        <div class="modal-header" id="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'course.Manage user connections' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-danger" ng-if="vm.error">{{ vm.error }}</div>
            <div class="form">
                <form-row>
                    <label class="label">{{ 'filter.Employee' | translate }}</label>
                    <div class="items">
                        <div class="ac02 open"">
                            <input ng-model="vm.name" ng-change="vm.search()" type="text" class="form-control" placeholder="Find an employee">
                        </div>
                    </div>
                </form-row>
                <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
                <div class="loader02" ng-if="vm.loading">
                    <p>{{ 'general.Please wait. Actions with large amount of data take more time than usual' | translate }}</p>
                </div>
                <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
                    <pagination-tools list="vm.list"></pagination-tools>
                    <table dt-options="vm.DATATABLES" class="data01">
                        <thead>
                            <tr>
                                <th>{{ 'filter.Employee' | translate }}</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr ng-repeat="item in vm.list.items" ng-class="{ status04: item.isInActive }">
                                <td>
                                    {{ item.displayName }}
                                </td>
                                <td class="actions">
                                    <a
                                        ng-if="!item.state && !vm.fileUserIds.includes(item.userId)"
                                        class="btn add"
                                        ng-click="item.state=2"
                                    >
                                        {{ 'general.Add a connection' | translate }}
                                    </a>
                                    <a
                                        ng-if="(!item.state || item.state==3) && vm.fileUserIds.includes(item.userId)"
                                        class="btn ico-check positive"
                                        ng-click="item.state=4"
                                    >
                                        {{ 'general.Connection added' | translate }}
                                    </a>
                                    <div ng-if="item.state==2">
                                        <span>{{ 'general.Are you sure?' | translate }}</span><br>
                                        <a class="btn ico-check positive icononly" ng-click="item.state=3;vm.addConnection(item.userId)">{{ 'general.Yes' | translate }}</a>
                                        <a class="btn ico-cross negatve icononly" ng-click="item.state=null">{{ 'general.No' | translate }}</a>
                                    </div>
                                    <div ng-if="item.state==4">
                                        <span>{{ 'general.Remove connection?' | translate }}</span><br>
                                        <a class="btn ico-check positive icononly" ng-click="item.state=null;vm.removeConnection(item.userId)">{{ 'general.Yes' | translate }}</a>
                                        <a class="btn ico-cross negatve icononly" ng-click="item.state=3">{{ 'general.No' | translate }}</a>
                                    </div>
                                </td>
                                <td class="actions">
                                    <a
                                        ng-if="!item.state_c && !vm.fileCertificateUserIds.includes(item.userId)"
                                        class="btn add"
                                        ng-click="vm.setStateC2(item)"
                                        ng-disabled="vm.isAssociated(item.userId)"
                                    >
                                        {{ 'general.Add as a certificate' | translate }}
                                    </a>
                                    <a
                                        ng-if="(!item.state_c || item.state_c==3) && vm.fileCertificateUserIds.includes(item.userId)"
                                        class="btn ico-check positive"
                                        ng-click="item.state_c=4"
                                    >
                                        {{ 'general.Certificate added' | translate }}
                                    </a>
                                    <div ng-if="item.state_c==2">
                                        <span>{{ 'general.Are you sure?' | translate }}</span><br>
                                        <a class="btn ico-check positive icononly" ng-click="item.state_c=3;vm.addCertificate(item.userId)">{{ 'general.Yes' | translate }}</a>
                                        <a class="btn ico-cross negatve icononly" ng-click="item.state_c=null">{{ 'general.No' | translate }}</a>
                                    </div>
                                    <div ng-if="item.state_c==4">
                                        <span>{{ 'general.Remove certificate?' | translate }}</span><br>
                                        <a class="btn ico-check positive icononly" ng-click="item.state_c=null;vm.removeCertificate(item.userId)">{{ 'general.Yes' | translate }}</a>
                                        <a class="btn ico-cross negatve icononly" ng-click="item.state_c=3">{{ 'general.No' | translate }}</a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <pagination list="vm.list"></pagination>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        class="btn main"
                        type="button"
                        ng-click="vm.save()"
                    >{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button
                        class="btn discrete"
                        type="button"
                        ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, ModalService, OccurrenceFileResource,
                 OccurrenceResource, ListFactory, Upload, DATATABLES) {
        this.DATATABLES = DATATABLES;
        this.$translate = $translate;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.OccurrenceResource = OccurrenceResource;
        this.OccurrenceFileResource = OccurrenceFileResource;
        this.ListFactory = ListFactory;
        this.Upload = Upload;

        this.fileUserIds = this.file.users.filter(item => item.isConnection).map(item => item.userId);
        this.fileCertificateUserIds = this.file.users.filter(item => item.isCertificate).map(item => item.userId);
        this.list = this.ListFactory.createWithPagination(
            this.OccurrenceResource.getParticipants.bind(this.OccurrenceResource)
        );
        this.list.pagination.perPage = 25;
        this.fetch();
    }

    search () {
        clearInterval(this.queryDelayId);
        this.queryDelayId = setTimeout(() => {
            this.fetch();
        }, '500');
    }

    setStateC2 (item) {
        if (!this.isAssociated(item.userId)) {
            item.state_c = 2;
        }
    }

    isAssociated (userId) {
        let associated = false;
        this.lodash.forEach(this.occurrence.files, (file) => {
            this.lodash.forEach(file.users, (user) => {
                if (user.userId === userId && user.isCertificate && file.id !== this.file.id) {
                    associated = true;
                }
            });
        });
        return associated;
    }

    fetch () {
        this.list.fetch({ privilegesCheck: 0 }, { occurrenceId: this.occurrence.id, name: this.name });
    }

    addConnection (userId) {
        this.fileUserIds.push(userId);
    }

    removeConnection (userId) {
        this.fileUserIds = this.fileUserIds.filter((id) => {
            return id !== userId;
        });
    }

    addCertificate (userId) {
        this.fileCertificateUserIds.push(userId);
    }

    removeCertificate (userId) {
        this.fileCertificateUserIds = this.fileCertificateUserIds.filter((id) => {
            return id !== userId;
        });
    }

    generateUsers () {
        const users = [];

        const ids = this.fileUserIds.concat(this.fileCertificateUserIds);
        ids.forEach((userId) => {
            users.push({
                userId,
                fileId: this.file.id,
                isCertificate: this.fileCertificateUserIds.includes(userId),
                isConnection: this.fileUserIds.includes(userId)
            });
        });
        return users;
    }

    save () {
        this.file.users = this.generateUsers();
        this.OccurrenceFileResource.update({
            id: this.file.id,
            expand: 'users'
        }, this.file).$promise.then(() => {
            this.uibModalInstance.close();
        }).catch((error) => {
            this.error = this.lodash.get(error.data, '[0].message');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/files/certificate/index.js